import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Form,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Label,
  FormGroup,
  Input,
  FormFeedback,
} from "reactstrap";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//Import Image
import { useFormik } from "formik";
import { AppDispatch } from "src";
import { useDispatch, useSelector } from "react-redux";
import { addUser, getUsers } from "src/slices/thunks";
import useToast from "src/components/Common/toast";
import { setToast } from "src/slices/toast/reducer";

const UsersCreate = () => {
  document.title = "Novo usuário - Khozi";
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const users = useSelector((state: any) => state.users.users || []);
  const { show, ToastComponent } = useToast();
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      username: "",
      first_name: "",
      last_name: "",
      email: "",
      telephone: "",
      superior: "",
      role: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Por favor, insira o nome de usuário"),
      first_name: Yup.string().required("Por favor, insira o nome completo"),
      last_name: Yup.string().required("Por favor, insira o nome completo"),
      email: Yup.string().required("Por favor, insira o email"),
      telephone: Yup.string().required("Por favor, insira o telefone"),
      superior: Yup.number().nullable().optional(),
      role: Yup.string().required("Por favor, insira a função"),
      password: Yup.string().required("Por favor, insira a palavra-passe"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), undefined], "As senhas devem coincidir")
        .optional(),
    }),
    onSubmit: values => {
      dispatch(addUser(values)).then((response: any) => {
        if (
          typeof response.payload === "string" &&
          response.payload.includes("Request failed with")
        ) {
          show("Erro", "Ocorreu um erro ao criar o usuário");
        } else {
          dispatch(getUsers());
          show("Sucesso", "Usuário criado com sucesso");
          dispatch(setToast({ action: "create-success" }));
          navigate("/users");
        }
      });
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {ToastComponent}
          <Breadcrumbs title="Usuário" breadcrumbItem="Definições de Usuário" />

          <Row>
            <div className="col-xxl-9">
              <Card>
                <CardBody>
                  <Form
                    className="needs-validation"
                    onSubmit={e => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="card border shadow-none mb-5">
                      <div className="card-header d-flex align-items-center">
                        <div className="flex-shrink-0 me-3">
                          <div className="avatar-sm">
                            <div className="avatar-title rounded-circle btn-primary-subtle text-primary">
                              01
                            </div>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="card-title">Usuário</h5>
                        </div>
                      </div>
                      <CardBody>
                        <div>
                          <Row>
                            <Col>
                              <FormGroup className="mb-3">
                                <Label htmlFor="validationCustom01">
                                  Nome de usuário
                                </Label>
                                <Input
                                  name="username"
                                  placeholder="Insira o nome de usuário"
                                  type="text"
                                  className="form-control"
                                  id="validationCustom01"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.username || ""}
                                  invalid={
                                    validation.touched.username &&
                                    validation.errors.username
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.username &&
                                validation.errors.username ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.username}
                                  </FormFeedback>
                                ) : null}
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col lg={6}>
                              <FormGroup className="mb-3">
                                <Label htmlFor="validationCustom01">
                                  Palavra-passe
                                </Label>
                                <Input
                                  name="password"
                                  placeholder="Insira a palavra-passe"
                                  type="password"
                                  className="form-control"
                                  id="validationCustom01"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.password || ""}
                                  invalid={
                                    validation.touched.password &&
                                    validation.errors.password
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.password &&
                                validation.errors.password ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.password}
                                  </FormFeedback>
                                ) : null}
                              </FormGroup>
                            </Col>
                            <Col lg={6}>
                              <FormGroup className="mb-3">
                                <Label htmlFor="validationCustom01">
                                  Confirmar palavra-passe
                                </Label>
                                <Input
                                  name="confirmPassword"
                                  placeholder="Confirmar palavra-passe"
                                  type="password"
                                  className="form-control"
                                  id="validationCustom01"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={
                                    validation.values.confirmPassword || ""
                                  }
                                  invalid={
                                    validation.touched.confirmPassword &&
                                    validation.errors.confirmPassword
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.confirmPassword &&
                                validation.errors.confirmPassword ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.confirmPassword}
                                  </FormFeedback>
                                ) : null}
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                      </CardBody>
                    </div>

                    <div className="card border shadow-none mb-5">
                      <div className="card-header d-flex align-items-center">
                        <div className="flex-shrink-0 me-3">
                          <div className="avatar-sm">
                            <div className="avatar-title rounded-circle btn-primary-subtle text-primary">
                              02
                            </div>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="card-title">Informações de Perfil</h5>
                        </div>
                      </div>
                      <CardBody>
                        <Row>
                          <Col md="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom01">Nome</Label>
                              <Input
                                name="first_name"
                                placeholder="Nome"
                                type="text"
                                className="form-control"
                                id="validationCustom01"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.first_name || ""}
                                invalid={
                                  validation.touched.first_name &&
                                  validation.errors.first_name
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.first_name &&
                              validation.errors.first_name ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.first_name}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                          </Col>
                          <Col md="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom01">
                                Sobrenome
                              </Label>
                              <Input
                                name="last_name"
                                placeholder="Sobrenome"
                                type="text"
                                className="form-control"
                                id="validationCustom01"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.last_name || ""}
                                invalid={
                                  validation.touched.last_name &&
                                  validation.errors.last_name
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.last_name &&
                              validation.errors.last_name ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.last_name}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom02">Email</Label>
                              <Input
                                name="email"
                                placeholder="Email"
                                type="text"
                                className="form-control"
                                id="validationCustom02"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={
                                  validation.touched.email &&
                                  validation.errors.email
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.email &&
                              validation.errors.email ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.email}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                          </Col>
                          <Col md="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom01">
                                Telefone
                              </Label>
                              <div className="d-flex align-items-center">
                                <span className="me-2">+258</span>
                                <Input
                                  name="telephone"
                                  placeholder="Telefone"
                                  type="text"
                                  className="form-control"
                                  id="validationCustom01"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.telephone || ""}
                                  invalid={
                                    validation.touched.telephone &&
                                    validation.errors.telephone
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                              {validation.touched.telephone &&
                              validation.errors.telephone ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.telephone}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom03">
                                Superior
                              </Label>
                              <Input
                                name="superior"
                                placeholder="Superior"
                                type="select"
                                className="form-control"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.superior || ""}
                                invalid={
                                  validation.touched.superior &&
                                  validation.errors.superior
                                    ? true
                                    : false
                                }
                              >
                                <option value="">Selecione</option>
                                {users.map((user: any) => (
                                  <option value={user.id} key={user.id}>
                                    {user.first_name} {user.last_name}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col md="6">
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom04">Função</Label>
                              <Input
                                name="role"
                                placeholder="Função"
                                type="select"
                                className="form-control"
                                id="validationCustom04"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.role || ""}
                                invalid={
                                  validation.touched.role &&
                                  validation.errors.role
                                    ? true
                                    : false
                                }
                              >
                                <option value="">Selecione</option>
                                <option value="AD">Administrador</option>
                                <option value="EX">Executivo</option>
                                <option value="OP">Planificador</option>
                              </Input>
                              {validation.touched.role &&
                              validation.errors.role ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.role}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                          </Col>
                        </Row>
                      </CardBody>
                    </div>
                    <div className="d-flex flex-wrap gap-2 justify-content-end">
                      <Button color="primary" type="submit">
                        Criar usuário
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </div>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UsersCreate;
